export default {
  // Navigation
  'nav.timer': 'Minuteur',
  'nav.stopwatch': 'Chronomètre',
  'nav.worldclock': 'Horloge Mondiale',
  'nav.timestamp': 'Horodatage',
  'nav.home': 'Accueil',

  // Common buttons and actions
  'button.start': 'Démarrer',
  'button.pause': 'Pause',
  'button.stop': 'Arrêter',
  'button.reset': 'Réinitialiser',
  'button.ok': 'OK',
  'button.cancel': 'Annuler',
  'button.close': 'Fermer',
  'button.save': 'Enregistrer',
  'button.delete': 'Supprimer',
  'button.edit': 'Modifier',
  'button.back': 'Retour',
  'button.next': 'Suivant',
  'button.previous': 'Précédent',
  'button.submit': 'Soumettre',
  'button.confirm': 'Confirmer',
  'button.convert': 'Convertir',
  'button.copy': 'Copier',
  'button.copied': 'Copié!',
  'button.now': 'Maintenant',
  'button.clear': 'Effacer',

  // Common labels
  'label.hours': 'Heures',
  'label.minutes': 'Minutes',
  'label.seconds': 'Secondes',
  'label.milliseconds': 'Millisecondes',
  'label.minute': 'Minute',
  'label.second': 'Seconde',
  'label.sound': 'Son',
  'label.soundAlert': 'Son',
  'label.fullscreen': 'Plein écran',
  'label.language': 'Langue',
  'label.selectLanguage': 'Sélectionner la langue',
  'label.languageSelectorInfo': 'Prend actuellement en charge {{count}} langues. Sélectionnez votre langue préférée parmi les options ci-dessus.',

  // Common messages
  'message.timerComplete': 'Minuteur Terminé!',
  'message.timerCompleteDesc': 'Votre minuteur est terminé',
  'message.timerCompleteBody': 'Votre minuteur inversé est terminé!',
  'message.stopwatchStarted': 'Chronomètre Démarré',
  'message.stopwatchStartedDesc': 'Le chronomètre a démarré',
  'message.stopwatchStopped': 'Chronomètre Arrêté',
  'message.stopwatchStoppedDesc': 'Le chronomètre a été interrompu',
  'message.stopwatchReset': 'Chronomètre Réinitialisé',
  'message.stopwatchResetDesc': 'Le chronomètre a été réinitialisé à zéro',
  'message.notificationPermission': 'Autorisez les notifications pour recevoir des alertes lorsque le minuteur se termine',
  'message.clickToEdit': 'Cliquez sur les chiffres de l\'heure pour modifier l\'heure directement',
  'message.addHours': '+ Ajouter des heures',
  'message.escToExit': 'Appuyez sur Échap pour quitter le plein écran',
  'message.timeRemaining': '{{minutes}} minutes {{seconds}} secondes restantes',
  'message.minutesRemaining': '{{minutes}} minutes restantes',
  'message.secondsRemaining': '{{seconds}} secondes restantes',
  'message.stopwatchTimeElapsed': '{{minutes}} minutes {{seconds}} secondes écoulées',
  'message.stopwatchMinutesElapsed': '{{minutes}} minutes écoulées',
  'message.stopwatchSecondsElapsed': '{{seconds}} secondes écoulées',
  'message.invalidTimestamp': 'Horodatage invalide',
  'message.invalidDateTime': 'Date et heure invalides',
  'message.conversionError': 'Erreur de conversion',

  // Time units
  'time.am': 'AM',
  'time.pm': 'PM',
  'time.now': 'Maintenant',
  'time.today': 'Aujourd\'hui',
  'time.yesterday': 'Hier',
  'time.tomorrow': 'Demain',

  // Common errors
  'error.pageNotFound': 'Page Non Trouvée',
  'error.somethingWrong': 'Quelque chose ne va pas',
  'error.tryAgain': 'Veuillez réessayer plus tard',

  // Footer
  'footer.about': 'À propos de timer.today',
  'footer.aboutDesc': 'timer.today est une plateforme d\'outils de chronométrage professionnelle en ligne offrant trois fonctionnalités principales:',
  'footer.timerDesc': 'Outil de compte à rebours personnalisable prenant en charge les paramètres de minutes et d\'heures, parfait pour la concentration au travail, le chronométrage de la cuisine, la gestion des études, etc. Dispose d\'alertes sonores et de notifications de bureau.',
  'footer.stopwatchDesc': 'Outil de chronométrage de haute précision avec une précision à la milliseconde, adapté aux entraînements sportifs, aux opérations culinaires, aux entraînements aux examens et à d\'autres scénarios nécessitant un chronométrage précis.',
  'footer.worldClockDesc': 'Affichage en temps réel des heures des principales villes du monde avec calculs intelligents des fuseaux horaires, facilitant la communication commerciale internationale et la collaboration entre fuseaux horaires.',
  'footer.timestampDesc': 'Convertisseur d\'horodatage Unix prenant en charge la conversion bidirectionnelle entre l\'horodatage et la date-heure, avec prise en charge des formats secondes et millisecondes.',
  'footer.termsOfService': 'Conditions d\'utilisation',
  'footer.privacy': 'Confidentialité',
  'footer.contactUs': 'Nous Contacter',
  'footer.changeLanguage': 'changer de langue',
  'footer.moreLanguage': 'plus de langues',
  'footer.copyright': '© timer.today 2024',

  // Quick actions
  'quick.add30s': '+30s',
  'quick.add1min': '+1 Min',
  'quick.add5min': '+5 Min',
  'quick.add10min': '+10 Min',
  'quick.add30min': '+30 Min',

  // Breadcrumb
  'breadcrumb.minuteTimer': 'Minuteur {{minutes}} Minutes',
  'breadcrumb.timer': 'Minuteur',
  'breadcrumb.stopwatch': 'Chronomètre',
  'breadcrumb.worldClock': 'Horloge Mondiale',
  'breadcrumb.termsOfService': 'Conditions d\'utilisation',
};